import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReactiveFormsModule} from "@angular/forms";
import {SalesAdditionalInformationComponent} from "./sales-additional-information.component";
import {SalesAdditionalInformationGeneralComponent} from "./general/sales-additional-information-general.component";
import {SalesAdditionalInformationGeneralV2Component, SalesAdditionalInformationGeneralV3Component} from "./general/versions/sales-additional-information-general-versions.component";
import {SalesAditionalInformationKredicashComponent} from "./kredicash/sales-aditional-information-kredicash.component";
import {LibraryModule} from "library";
import {PrimengModule} from "projects/store/src/app/components/shared/primeng-module/primeng.module";
import {SalesAdditionalInformationFieldContactComponent} from "./fields/contact/sales-additional-information-field-contact.component";
import {SalesAdditionalInformationFieldDropdownComponent} from "./fields/dropdown/sales-additional-information-field-dropdown.component";
import {SalesAdditionalInformationFieldPhoneComponent} from "./fields/phone/sales-additional-information-field-phone.component";
import {SalesAdditionalInformationFieldEmailComponent} from "./fields/email/sales-additional-information-field-email.component";
import {SalesAdditionalInformationFieldRadioComponent} from "./fields/radio/sales-additional-information-field-radio.component";
import {SalesAdditionalInformationFieldStringComponent} from "./fields/string/sales-additional-information-field-string.component";
import { SalesAdditionalInformationFieldAddresColombiaComponent } from './fields/address/addres-colombia/sales-additional-information-field-addres-colombia.component';
import {GeneralModule} from "../general/general.module";
import {
  SalesAdditionalInformationFieldSalaryComponent
} from "./fields/salary/sales-additional-information-field-salary.component";
import { SalesAdditionalInformationExperanzaClientComponent } from 'projects/store/src/app/components/sales/additional-information/general/experanza-client/sales-additional-information-experanza-client.component';



@NgModule({
  declarations: [
    SalesAdditionalInformationComponent,
    SalesAdditionalInformationGeneralComponent,
    SalesAdditionalInformationGeneralV2Component,
    SalesAdditionalInformationGeneralV3Component,
    SalesAditionalInformationKredicashComponent,
    SalesAdditionalInformationFieldContactComponent,
    SalesAdditionalInformationFieldDropdownComponent,
    SalesAdditionalInformationFieldEmailComponent,
    SalesAdditionalInformationFieldPhoneComponent,
    SalesAdditionalInformationFieldRadioComponent,
    SalesAdditionalInformationFieldStringComponent,
    SalesAdditionalInformationFieldAddresColombiaComponent,
    SalesAdditionalInformationFieldSalaryComponent,
    SalesAdditionalInformationExperanzaClientComponent
  ],
    imports: [
        CommonModule,
        LibraryModule,
        PrimengModule,
        ReactiveFormsModule,
        GeneralModule,
    ],
  exports: [
    SalesAdditionalInformationComponent,
    SalesAdditionalInformationGeneralComponent,
    SalesAditionalInformationKredicashComponent
  ]
})
export class SalesAdditionalInformationModule { }
